import { useIsXs } from '@/forms/shared/EnsContainerObserver';
import { useAppSelector } from '@/hooks';
import { createSlice } from '@reduxjs/toolkit';

const ensOptionsSlice = createSlice({
  name: 'ensOpt',
  initialState: {} as EnsOptions,
  reducers: {},
});

export const useEnsOptions = () => useAppSelector((state) => state.ensOptions);

export const useFullsizeCalculator = () => {
  const options = useEnsOptions();
  return options?.fullWidth && options.isFullscreen;
};

export const useFullScreenContainerPadding = () => {
  const isXs = !useIsXs();
  return useFullsizeCalculator() && isXs ? 'md' : 0;
};

export default ensOptionsSlice.reducer;
